import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";
import editGoal from "../../../assets/editIcon.png";

function EditGoal() {
  const { t } = useTranslation();
  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I edit goal?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.ISavings.editGoal.step1")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.ISavings.editGoal.step2")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.ISavings.editGoal.step3")}
          <img src={editGoal} alt="icon" className="inline-flex w-8" />
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.ISavings.editGoal.step4")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default EditGoal;
